import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DoneOutlineIcon(props: IconProps) {
    return <Icon {...props} iconKey={"done_outline"}/>
}
